<template>
  <div style="background: #fff; min-width: 1200px">
    <div v-if="type == 'main'">
	<div v-if="!showTab" style="height: 60px;"></div>
    <header-menu v-if="showTab"/>
    <transition name="el-fade-in-linear">
      <div style="min-height: calc(calc(100vh - 50px - 38px - 30px) - 2px)">
        <router-view />
      </div>
    </transition>
    <footer-content v-if="showTab"/>
    </div>
    <div style="min-height: calc(calc(100vh - 50px - 38px - 30px) - 2px); display: flex;align-content: flex-end;justify-content: center;align-items: top;" v-if="type == 'tenant'">
	  <change-tenant></change-tenant>
    </div>
  </div>
</template>

<script>
import HeaderLogin from "./views/header/header-login";
import HeaderMenu from "./views/header/header-menu";
import FooterContent from "./views/footer/footer-content";
import changeTenant from "./views/tenant/change-tenant"
import Cookies from "js-cookie";
import { messages } from "@/i18n";
export default {
  data() {
    return {
      overWidth: true,
      type: null,
	  showTab: true
    };
  },
  watch: {
    "$i18n.locale": "i18nHandle",
    '$route' (to, from) { //监听路由是否变化
      if (to.query['type'] == 'tenant'){ //跳转到哪个页面
        this.type = 'tenant';
      } else {
        this.type = 'main';
      }
    },
  },
  components: {
    HeaderLogin,
    HeaderMenu,
    FooterContent,
    changeTenant,
  },
  created() {
    this.i18nHandle(this.$i18n.locale);
	if(this.getLocalStorage("stopTab") === 40001) {
		console.log(this.getLocalStorage("stopTab"),88888888)
		this.showTab = false;
	}
  },
  methods: {
    i18nHandle(val, oldVal) {
      window.sessionStorage.setItem("language", val);
      document.querySelector("html").setAttribute("lang", val);
      document.title = messages[val].brand.lg;
      // 非登录页面，切换语言刷新页面
      if (this.$route.name !== "login" && oldVal) {
        window.location.reload();
      }
    },
  },
  mounted() {
    let width = `${document.documentElement.clientWidth}`;
    if (width < 800) {
      this.overWidth = false;
    }
    window.onresize = function temp() {
      let width = `${document.documentElement.clientWidth}`;
      if (this.overWidth) {
        if (width < 800) {
          // alert('手机端')
          this.overWidth = false;
        }
      } else {
        if (width > 800) {
          // alert('网页端')
          this.overWidth = true;
        }
      }
    };
  },
};
</script>
